<template>
    <div class="event-check">
        <div class="event-check-circle-container">
            <svg class="event-check-circle"
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="6" fill="#3B66D3"/>
            </svg>
        </div>
        <div class="event-check-title event-check-text">
            {{ labelText }}
        </div>
        <input
        class="event-check-checkbox"
        type="checkbox" 
        name="scales"
        v-model="checked"
        />
    </div>
</template>

<script>

export default {
    name: 'EventCheck',
    data(){
        return {
            checked: true
        }
    },
    props:{
        labelText: String
    },
    watch: {
        checked(oldValue,newValue){
            console.log('newValue')
            console.log(newValue)
            if (oldValue!=newValue){
                this.$emit('clickCheckbox', !newValue)
            }
        }
    }
}
</script>
